import { render } from "./Home.vue?vue&type=template&id=bd0a3ae4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bd0a3ae4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd0a3ae4"

export default script